export enum UserMessages {
    UseGlobal = 'Use the global preset target for this measure',
    SetKMI = 'Set target to add KMI notifications',
    //FP-9815. KMI help text ----
    AimToExceedHelptext = 'Email notification will be sent once when the value is equal to or less than the target value',
    StayUnderHelptext = 'Email notification will be sent once when the value reaches or exceeds the target value',
    StayCloseToHelptext = 'Email notification will be sent once while the value is not within 10% of the target value',
    //----
    SetEmail = 'Set Target to update email preference',
    DeleteFailed = 'Deleting target configuration failed',
    MissingTargetType = 'Must set target type to save',
    MissingTargetValue = 'Must set target value to save',
    InvalidData = 'Invalid Target Data Supplied',
    GenericError = 'An error occurred saving the target',
    NoUserTarget = 'No Personal Target is Set',
    NoGlobalTarget = 'No Global Target is Set',
}
